import * as React from "react";
import RoomComponentForm from "../../components/Forms/MassConfigPremisesComponents/RoomComponentForm/RoomComponentForm";

export default function MassConfigRoomComponentSetup() {
  return <RoomComponentForm />;
}
